var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"smvp-sidebar-poll-results"},[_c('span',{staticClass:"question"},[_vm._v(_vm._s(_vm.question))]),_vm._l((_vm.results),function(result,index){return _c('result-answer',{key:index,attrs:{"correct":result.correct,"selected":result.selected,"text":result.text,"percentage":result.percentage}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }